import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import $ from 'jquery';
import {Api} from '../../../utils/Variables';

import PsContext from '../../context/PsContext';

class NavSingleItem extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			
		}
		
	}
	
	componentDidMount(){
		
	}
	
	
	render(){
		const item = this.props.item;
		
		return(
			<li>
				<NavLink to={item.url} exact={item.exact} onClick={this.props.menuClose} > 
					<i className={item.icon} ></i> 
					{item.name} 
				</NavLink>
			</li>
		);
	}
	
}
export default NavSingleItem;
